import { useEffect, useRef, useState } from 'react';

const MIN_BODY_HEIGHT = 300;

type MailBodyFrameProps = {
  html: string;
};

export const MailBodyFrame = ({ html }: MailBodyFrameProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState(0);

  const srcDoc = `${IFRAME_DOC_PREFIX}${html}${IFRAME_DOC_SUFFIX}`;

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    let resizeObserver: ResizeObserver | null = null;

    const handleLoad = () => {
      const doc = iframe.contentDocument;
      if (!doc) return;

      doc.querySelectorAll('a').forEach(anchor => {
        anchor.setAttribute('target', '_blank');
        anchor.setAttribute('rel', 'noopener noreferrer');
      });

      const measure = () => setHeight(Math.max(MIN_BODY_HEIGHT, doc.body.scrollHeight + 2));
      measure();

      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(doc.body);
    };

    iframe.addEventListener('load', handleLoad);
    return () => {
      iframe.removeEventListener('load', handleLoad);
      resizeObserver?.disconnect();
    };
  }, [srcDoc]);

  return (
    <iframe
      ref={iframeRef}
      srcDoc={srcDoc}
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      title="mail-body"
      style={{ width: '100%', height, border: 'none', display: 'block' }}
    />
  );
};

const IFRAME_DOC_PREFIX = `<!doctype html><html><head>
<meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<style>
  html, body { margin: 0; padding: 0; }
  img { max-width: 100%; height: auto; }
</style>
</head><body>`;
const IFRAME_DOC_SUFFIX = `</body></html>`;
